import styled from "styled-components"

const StyledContainer = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${(props) => props.theme.fontsHeading};
  }
  a,
  p,
  span,
  label,
  button,
  input,
  article,
  aside,
  div,
  blockquote,
  details,
  figcaption,
  figure,
  summary,
  option,
  optgroup,
  select,
  textarea,
  fieldset,
  legend {
    font-family: ${(props) => props.theme.fontsText};
  }
  [class*="-title"] a {
    &::before {
      background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    }
  }

  [class*="-title"] {
    &::before {
      background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    }
  }

  .btn {
    color: #fff;
    &::before {
      background-color: ${(props) => props.theme.b_color_gradients.b_dark};
    }
    &::after {
      background-color: ${(props) => props.theme.a_color_gradients.a_dark};
    }
  }
  blockquote {
    border-left: 3px solid ${(props) => props.theme.a_color_gradients.a_dark};
  }
  @media (max-width: 900px) {
    blockquote {
      border-top: 3px solid ${(props) => props.theme.a_color_gradients.a_dark};
      border-bottom: 3px solid
        ${(props) => props.theme.a_color_gradients.a_dark};
      border-left: none;
    }
  }
`

export default StyledContainer
